import { trackClick } from '@hotjar/webapp/features/Playbacks/utils/tracking';
import { Store } from '../../../store/player/types';

/**
 * Triggered when user clicks the `Start Collecting Feedback` button in
 * the session end modal.
 */

export const onCreateFeedback = (store: Store): void => {
  const { recording } = store.getState();
  if (!recording) return;

  trackClick(recording, {
    element_name: 'shared_recording_create_feedback_btn',
    ui_position: 'Feedback upsell in Recording end modal',
  });
};
